import { useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Spinner from '../../../shared/Spinner'
import { SKIP_AUTO_LOGIN_ONCE_KEY, useAuthContext } from '../../../../state/useAuth'
import { ROUTES } from '../../../../constants/routes'

const getSafeReturnPath = (returnTo?: string | null): string | undefined => {
  if (!returnTo) return undefined
  if (!returnTo.startsWith('/')) return undefined
  if (returnTo.startsWith('//')) return undefined
  return returnTo
}

const Login = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { authData, isAuthInitialized, isKeycloakConfigured, login } = useAuthContext()

  const returnTo = useMemo(() => getSafeReturnPath(searchParams.get('returnTo')), [searchParams])

  useEffect(() => {
    if (!isAuthInitialized) return

    try {
      if (sessionStorage.getItem(SKIP_AUTO_LOGIN_ONCE_KEY) === '1') {
        sessionStorage.removeItem(SKIP_AUTO_LOGIN_ONCE_KEY)
        navigate(ROUTES.LANDING_PAGE, { replace: true })
        return
      }
    } catch {}

    if (authData?.access_token) {
      navigate(authData.userRole === 'admin' ? ROUTES.ADMIN_PANEL : ROUTES.DATASETS, { replace: true })
      return
    }

    if (!isKeycloakConfigured) return

    login(returnTo).catch(() => {})
  }, [authData?.access_token, authData?.userRole, isAuthInitialized, isKeycloakConfigured, login, navigate, returnTo])

  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
    >
      <Spinner widthHeight={42} />
    </div>
  )
}

export default Login
